
    <div *ngIf="entity">
      [SELECT TARGET]
    </div>
  